import { render } from "./IconRestore.vue?vue&type=template&id=768ad011"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconRestore.vue"]])

export default __exports__